import { Icon, type IconProps } from "@chakra-ui/icon";

const BrandWarnIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#FEF2F2" />
			<g clipPath="url(#clip0_10254_10278)">
				<path
					d="M16.0002 13.3335V16.0002M16.0002 18.6668H16.0068M22.6668 16.0002C22.6668 19.6821 19.6821 22.6668 16.0002 22.6668C12.3183 22.6668 9.3335 19.6821 9.3335 16.0002C9.3335 12.3183 12.3183 9.3335 16.0002 9.3335C19.6821 9.3335 22.6668 12.3183 22.6668 16.0002Z"
					stroke="#B91C1C"
					strokeWidth="1.33"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10254_10278">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(8 8)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
};

export default BrandWarnIcon;
